import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import components from '@/components/UI'
import icons from '@/components/icons'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import VueMask from 'v-mask'

// console.log(process.env)

let axiosInstanse = axios.create({
  baseURL: '/booking',
})

Vue.use(VueAxios, axiosInstanse)

Vue.use(VueMask, {
  placeholders: {
    L: /[а-яА-Я]/,
  }
})

Vue.config.productionTip = false

components.forEach(component => {
  Vue.component(component.name, component)
})

for(let icon in icons) {
  Vue.component(`icon-${icon}`, icons[icon])
}

Vue.component('vue-slick-slider', VueSlickCarousel)

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#bookingApp')
